import Analytics from './analytics';

class RelatedTalks {
    constructor(rootElement, tns) {
        this.rootElement = rootElement;
        this.tns = tns;
        this.initialize(rootElement);
    }

    initialize = (rootElement) => {
        const container = rootElement.querySelector('.related-talks__items');
        const isPodcast = rootElement.classList.contains('related-talks--podcast');

        this.tns({
            container: container,
            slideBy: 'page',
            autoplay: false,
            controls: true,
            nav: false,
            navPosition: 'bottom',
            speed: 250,
            mouseDrag: false,
            gutter: 8,
            controlsText: ['', ''],
            items: 1,
            loop: false,
            onInit: (instance) => {
                instance.nextButton.ariaLabel = "Framåt";
                instance.prevButton.ariaLabel = "Bakåt";

                if (isPodcast) {
                    this.attachClickTracking(rootElement);
                }
            },
            responsive: {
                768: {
                    slideBy: 'page',
                    items: 2,
                    gutter: 24
                },
                992: {
                    slideBy: 'page',
                    items: 3,
                    gutter: 24
                },
            }
        });
    }

    attachClickTracking = (rootElement) => {
        const talkLinks = rootElement.querySelectorAll('.related-talks__talk');

        talkLinks.forEach(link => {
            link.addEventListener('click', () => {
                if (window.dataLayer) {
                    const headline = link.dataset.headline || '';

                    window.dataLayer.push({
                        'event': 'aiPodBannerClick',
                        'aipodHeadline': headline,
                        'isAuthenticated': Analytics.getAuthenticated(),
                        'selectedBranch': Analytics.getBranchName()
                    });
                }
            });
        });
    }
}

document.addEventListener('DOMContentLoaded', function () {
    const relatedTalks = [...document.querySelectorAll('.related-talks')];
    if (relatedTalks.length === 0) return;

    import("tiny-slider").then(({ tns }) => {
        relatedTalks.forEach((rootElement) => new RelatedTalks(rootElement, tns));
    });
});